import { AfterViewInit, Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { ApiState } from 'src/app/model/api-state.model';
import { BACKOFFICE_PERMISSION } from 'src/app/page/offer/offer.component';
import { ModalService, ModalType } from 'src/app/services/modal.service';
import { PersistStorageKeys, PersistStorageService } from 'src/app/services/persist-storage.service';
import { AppState } from 'src/app/store';
import * as fromProcess from '../../store/process/process.reducer';
import isAppAgentOrTravelAgency from '../../utils/is-agent-or-travel-agency.util';

const BOX_PERCENTAGE_VISIBLE = 0.3;

@Component({
  selector: 'app-price-tag',
  templateUrl: './price-tag.component.html',
  styleUrls: ['./price-tag.component.scss'],
})
export class PriceTagComponent implements AfterViewInit {
  @ViewChild('priceTagAmount') offerPriceBox!: ElementRef<HTMLElement>;
  @Input() amount?: number | null;
  @Input() amountBeforeDiscount?: number | null;
  @Input() currency!: string;

  offerQuotationState$ = this.store.select(fromProcess.selectOfferQuotationState);

  isAppAgentOrTravelAgency = isAppAgentOrTravelAgency();
  isBackoffice = false;

  protected readonly apiState = ApiState;

  constructor(private modalService: ModalService, private persistStorage: PersistStorageService, private store: Store<AppState>) {
    this.isBackoffice = this.persistStorage.getString(PersistStorageKeys.AgentCategory) === BACKOFFICE_PERMISSION;
  }
  @HostListener('window:resize', [])
  @HostListener('window:scroll', [])
  onScrollOrResize() {
    this.checkIfOfferPriceBoxIsVisible();
  }

  ngAfterViewInit(): void {
    this.checkIfOfferPriceBoxIsVisible();
  }

  checkIfOfferPriceBoxIsVisible(): void {
    if (this.offerPriceBox && this.offerPriceBox.nativeElement.offsetParent) {
      const { offsetHeight: priceBoxHeight } = this.offerPriceBox.nativeElement;
      const { top: rectTop, bottom: rectBottom } = this.offerPriceBox.nativeElement.getBoundingClientRect();
      const topShown = rectTop >= -(BOX_PERCENTAGE_VISIBLE * priceBoxHeight);
      const bottomShown = rectBottom <= window.innerHeight;
      const isOfferPriceBoxVisible = topShown && bottomShown;

      this.store.dispatch(fromProcess.actions.setIsOfferPriceBoxVisible({ isOfferPriceBoxVisible }));
    }
  }

  showChangePremiumModal(): void {
    this.modalService.openModal(ModalType.ChangePremium, { maxWidth: '736px' });
  }
}
